import { apiClient, getPlatformUrl } from "../../lib/api";

export class CausalAiGateway {
  async fetchRelevanceDef(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/v2/graph/nodes/relevance?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchStratNodesDef(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/v2/graph/strat/nodes?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchStratBoundsDef(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/graph/strat/bounds/${req}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async setStratBoundsDef(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/graph/strat/bounds`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async deleteStratBoundsDef(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/graph/strat/bounds/${req}`;
    const res = await apiClient.remove({ url: url });
    return res as any;
  }

  async fetchDistributeDef(req: any): Promise<any> {
    const query = new URLSearchParams(req).toString();
    const url = `${getPlatformUrl()}/xcausal/cate/distribution?${query}`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchInspectionDef(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/graph/nodes/inspection`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchRobustnessDef(model_id: string, req: any): Promise<any> {
    const url = `${getPlatformUrl()}/api/message-queue/data-robustness/${model_id}/limited-parameter-estimation`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchRobustnessStatus(task_id: string): Promise<any> {
    const url = `${getPlatformUrl()}/api/message-queue/status?task_id=${task_id}`;
    const res = await apiClient.get({ url: url});
    return res as any;
  }

  async fetchRobustnessResult(task_id: string): Promise<any> {
    const url = `${getPlatformUrl()}/api/message-queue/result?task_id=${task_id}`;
    const res = await apiClient.get({ url: url});
    return res as any;
  }

  async fetchExDoDw(model_id: string, req: any): Promise<any> {
    const url = `${getPlatformUrl()}/api/data-robustness/dwmodel/${model_id}/exhaustive-do-dw`;
    const res = await apiClient.post({ url: url, body: req });
    return res as any;
  }

  async fetchPublishExDo(report_id: string): Promise<any> {
    const url = `${getPlatformUrl()}/api/data-robustness/dwmodel-report-do/${report_id}/publish-exhaustive-do`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchInterventionDistribution(model_id: string, node_value: string): Promise<any> {
    const url = `${getPlatformUrl()}/causal-inference/bnmodel/${model_id}/node/${node_value}/distribution`;
    const res = await apiClient.get({ url: url });
    return res as any;
  }

  async fetchBNModelList(): Promise<any[]> {
    const base = getPlatformUrl();
    const analysisRes = await apiClient.get({
      url: `${base}/causal-inference/analysis?page=1&items_per_page=1000`,
      useToken: true,
    });
    const analyses: any[] = analysisRes?.analyses || [];
    const allModels: any[] = [];
    for (const analysis of analyses) {
      const dwRes = await apiClient.get({
        url: `${base}/causal-inference/analysis/${analysis.id}/dwmodel?page=1&items_per_page=1000&is_fixed=true`,
        useToken: true,
      });
      const models: any[] = dwRes?.dwmodels || [];
      models.forEach((m: any) => allModels.push({ ...m, analysis_id: analysis.id }));
    }
    return allModels;
  }

  async fetchBNModelDetail(model_id: string): Promise<any> {
    const url = `${getPlatformUrl()}/causal-inference/dwmodel/${model_id}`;
    const res = await apiClient.get({ url, useToken: true });
    return res as any;
  }

  async fetchGeneratePDF(req: any): Promise<any> {
    const url = `${getPlatformUrl()}/xcausal/v2/graph/generate-pdf`;
//    const url = "http://localhost:8080/xcausal/v2/graph/generate-pdf";
    const res = await apiClient.upload({ url: url, body: req, responseType: 'blob' });
    return res as any;
  }
}
